import { initCursorFollowsURL } from './cursorFollowsURL'
import { initAutoScroll } from './autoScroll'
import { initRemoteImportExport } from './sync/remoteImportExport'
import { initKeyboardListener } from './keyboard'
import { initTreeEngine } from './treeEngine'

export const initControllers = () => {
    initCursorFollowsURL()
    initAutoScroll()
    initRemoteImportExport()
    initKeyboardListener()
    initTreeEngine()
}
